import axios from 'axios'

const ENDPOINT_DOLLI = process.env.REACT_APP_ENDPOINT_DOLLI
const ENDPOINT_CONTENT = `${ENDPOINT_DOLLI}/rcl/content`
const options = {
  headers: {
    accept: 'application/json',
  },
}

const endpoints = {
  brands: `${ENDPOINT_CONTENT}/brands`,
  ships: `${ENDPOINT_CONTENT}/ships`,
  calendar: `${ENDPOINT_DOLLI}/rcl/calendar`,
  sso: `${process.env.REACT_APP_SSO_ENDPOINT}agent/`,
}

export function getBrands() {
  return axios.get(endpoints.brands, options)
}

export function getShips() {
  return axios.get(endpoints.ships, options)
}

export function getRegions() {
  return axios.get(endpoints.regions, options)
}

export function getCalendar(date, brand, ship) {
  const url = `${endpoints.calendar}/${date}?brand=${brand}&ship=${ship}`
  return axios.get(url, options)
}

export function getSso(agentId, sessionId) {
  const time = new Date().getTime()
  const url = `${endpoints.sso}${agentId}?sessionId=${sessionId}&renewData=${time}`
  return axios.get(url, options)
}

export default endpoints
